import { makeDateWindowSchema } from "./dateWindow.js";
/**
 * Query contract for GET /orgs/:orgId/utility-monthly. The window is REQUIRED
 * (the RPC's own params are optional; the route insists so the "bounded by
 * construction" row-count argument actually holds) and must be a real, ordered
 * calendar range.
 *
 * Capped at 120 months (10 years). Unlike get_monthly_net_flow, this RPC does
 * NOT scaffold months — it groups over place_utility_monthly rows that exist,
 * so a 10,000-year window returns only the org's real months (measured: 108
 * rows, 1.8ms) and the width is not itself a cost lever. The cap is therefore
 * defence-in-depth, not a fix for a live vector: it bounds pathological input
 * and, more usefully, stops a future scaffold from silently turning this into
 * the one get_monthly_net_flow had.
 *
 * 10 years rather than the net-flow schema's 36 months because the dashboard
 * picker's Custom option passes the user's chosen range straight through here,
 * so the legitimate maximum is whatever a person can select — far wider than
 * any single tile's fixed window.
 */
export const orgUtilityMonthlyQuerySchema = makeDateWindowSchema(120);
/** Coded error envelopes of the project-place writes (the web reads `err.envelope?.code`). */
export const PROJECT_PLACE_ERROR_CODES = {
    /**
     * 409 — the place is already linked to the project under this role (DB:
     * the unique constraint `unique_project_place_role` on
     * `(project_id, place_id, role)`).
     */
    alreadyLinked: "already_linked",
    /**
     * 400 — the end date is before the start date (DB: the CHECK
     * `project_places_dates_check`; reached when a PATCH sends one end and the
     * stored other end makes the range invalid — a reversed range inside one
     * payload is the schema refine's plain 400).
     */
    invalidDateRange: "invalid_date_range",
};
//# sourceMappingURL=placesReads.js.map